import { styled } from "solid-styled-components";

export const OverlayLogo = styled.img`
  width: min(40%, 150px);
`;
